module.exports = {
  src: __webpack_public_path__ + "assets/images/copy-icon.c206920a443a3f0b.svg",
  width: 14,
  height: 16,
  toString: function() { return __webpack_public_path__ + "assets/images/copy-icon.c206920a443a3f0b.svg"; }
};